import * as angular from "angular";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { CustomFieldAttachmentModel } from "../../models/custom-field-attachment.model";
import { HouseOccupant } from "../../models/house-occupant.model";

let ViewCustomFieldAttachmentComponent = {
    selector: "vcViewCustomFieldAttachment",
    templateUrl:
        "/angular/components/custom-fields/view-custom-field-attachment.component.html",
    bindings: {
        file: "=",
        houseoccupant: "=",
    },
    controller: class ViewCustomFieldAttachment {
        // * bindings for typescript compiler *
        public file: CustomFieldAttachmentModel;
        public houseoccupant: HouseOccupant;
        // ************************************

        public $scope: any;
        public isLeaderView: boolean;
        public dialog: DialogUtils;
        public dataProvider: FieldDataProvider;

        constructor(
            $scope: any,
            FieldDataProvider: FieldDataProvider,
            DialogUtils: DialogUtils,
            __app_type: string
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.dataProvider = FieldDataProvider;
            this.isLeaderView = __app_type == "LEADER";
        }

        $onInit() {
            if (this.file.url && this.file.url != "") {
                document
                    .getElementById("embed-pdf")
                    .setAttribute("src", this.file.url);
            } else {
                let data: any = { id: this.file.cfoid };
                this.dataProvider.getAttachment(data).then((data: any) => {
                    this.file.setData(data);
                    document
                        .getElementById("embed-pdf")
                        .setAttribute("src", this.file.url);
                });
            }
        }

        cancel(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("customField")
    .component(
        ViewCustomFieldAttachmentComponent.selector,
        ViewCustomFieldAttachmentComponent
    );
